import {
  Avatar,
  AvatarImage,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
  ScrollArea,
} from "alm-react-components";
import { t } from "i18next";
import { useContext, useEffect, useLayoutEffect, useState } from "react";
import { ActionType, corporateKeys } from "../../assets/constants/constants";
import editprofileIcon from "../../assets/images/svgicons/edit-profile-icon.svg";
import defaultUserImg from "../../assets/images/user-mtbg.svg";
import { AppContext } from "../../context/AppProvider";
import { allStorage, checkCorporateAdminAcount, clearLocalStorage, getRedirectPaths, isOpenChainlit, removeChainlitPopup } from "../../lib/utils";

import { fetchUserAttributes, signOut } from "aws-amplify/auth";
import {  useLocation, useNavigate } from "react-router-dom";
import { constants } from '../../assets/constants/constants.ts';
import { analytics_category, analytics_event, analytics_label } from '../../assets/constants/staticContentConstants';
import ChevronRight from "../../assets/images/chevron-right.svg";
import Setting from "../../assets/images/settings.svg";
import InfoCircle from "../../assets/images/svgicons/info-circle-icon.svg";
import ChangePassword from "../../assets/images/svgicons/log-out-icon.svg";
import useGaEventTracking from '../../hooks/UseGaEventTracking';
import { sendStorageToBakend } from "../../services/user.ts";
export const UserProfileSection = () => {
  const [profileSettings, setProfileSettings] = useState(false);
  const { state, dispatch } = useContext(AppContext);
  const [avatarUrl, setAvatarUrl] = useState("");
  const navigate = useNavigate();
  const [socialLogin, setSoaialLogin] = useState<any>(false);
  const gaEventTracker = useGaEventTracking();
  const location = useLocation();
  let diffInMinutes: any;
  let diffInSeconds:any;
  const onHandleLogout = async () => {
    removeChainlitPopup()
    dispatch({ type: ActionType.GLOBAL_CHATBOT_KEY_LOGOUT, payload: true });
  
    sessionStorage.removeItem("lastActiveTimestamp");
    sessionStorage.removeItem("popupExpiryTimestamp");

    const login_time = localStorage.getItem('login_time');
    if (login_time) {
     const targetTime = new Date(login_time);
     const currentTime = new Date();
     const diffInMilliseconds =  currentTime.getTime() - targetTime.getTime() ;
     diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
     diffInSeconds = Math.floor((diffInMilliseconds % (1000 * 60)) / 1000); 
    } 
      const items = {
        value: null,
        currency: null,
        transaction_id: null,
        items: [{}],
        userId:state.user?.userId,
        sessionDuration:`${diffInMinutes}:${diffInSeconds}`,
        logout_method:constants.Custom
        
    };
  
    gaEventTracker(analytics_event.logOut,analytics_category.buttonClickLogOut,analytics_label.logOutLable,items);
    dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: true });
   
     fetchUserAttributes().then((res:any)=>{
          signOut().then(() => {
            if(res?.email_verified == "true"){
              navigate("/");
              sessionStorage.removeItem("lastActiveTimestamp");
              sessionStorage.removeItem("popupExpiryTimestamp");
            }
          }).catch(() => {
            dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: false });
          });
      }).catch(() => {
        clearLocalStorage()
        navigate("/");
        dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: false });
      });
   };
  const isUserSocialLoggedIn = async () => {
    const fetchUserAttributesData: any = await fetchUserAttributes();
    dispatch({ type: ActionType.IS_SOCIAL_LOGIN, payload: true });
    setSoaialLogin(JSON.parse(fetchUserAttributesData?.email_verified));
  };
  useEffect(() => {
    if(state.isAuthenticated) {
      isUserSocialLoggedIn();
    }
  }, [state.isAuthenticated]);

  useEffect(() => {
    if (state.user?.avatarUrl) {
      setAvatarUrl(state.user?.avatarUrl);
    }
  }, [state.user?.avatarUrl]);

  const handleMouseEnter = (e: any) => {
    if (e && !state.chatBot) {
      dispatch({ type: ActionType.CHAT_BOT_STATE, payload: true });
    } else {
      dispatch({ type: ActionType.CHAT_BOT_STATE, payload: false });
    }
     
    if (isOpenChainlit()) 
      window.toggleChainlitCopilot();

    setProfileSettings(!profileSettings);
  };

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (history.scrollRestoration) {
      history.scrollRestoration = "manual";
    }
  }, []);

  const redirectToAdminPanel= async()=>{ 
    dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: true });
    await sendStorageToBakend(allStorage()).then(()=>{
      const awsToken=localStorage.getItem("token")
      dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: false });
      clearLocalStorage();
      window.location.href=`${corporateKeys?.CORPORATE_URL}?awsToken=${awsToken}`; 
    })
  }

  return (
    <DropdownMenu
      open={profileSettings}
      onOpenChange={(e) => handleMouseEnter(e)}
    >
      <div className="">
        {state.user && (
          <DropdownMenuTrigger
            onClick={(e) => handleMouseEnter(e)}
            asChild
            className="cursor-pointer"
          >
            <Avatar
              className="flex text-sm ml-4 bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
              id="user-menu-button"
              aria-expanded="false"
              data-dropdown-toggle="user-dropdown"
              data-dropdown-placement="bottom"
            >
              {state.user && avatarUrl != "" ? (
                <AvatarImage
                  className="object-cover"
                  src={avatarUrl}
                  alt="@shadcn"
                />
              ) : (
                <AvatarImage
                  className="object-cover"
                  src={defaultUserImg}
                  alt="@shadcn"
                />
              )}
            </Avatar>
            {/* Dropdown menu */}
          </DropdownMenuTrigger>
        )}
        <DropdownMenuContent className="w-[335px] py-3 z-[50] mr-2 dark:bg-navActive">
          <div className="p-4 pt-1 grid justify-items-center border-b-[1px] border-gray-700 rounded-none">
            <h1 className="font-barlowRegular text-xl">{state.user?.name}</h1>
            <h3 className="text-sm">{state.user?.email}</h3>
            {/* <h3 className="text-sm">PhoneNumber</h3> */}
          </div>
          <ScrollArea className="landscape:max-md:h-[calc(210px-83px)] md:h-[calc(312px-83px)] hidden"></ScrollArea>
          <ScrollArea className="">
          {checkCorporateAdminAcount(state.user?.sllCorporateAccountRoles) && (
              <DropdownMenuItem
                onClick={() => {
                  redirectToAdminPanel()
                }}
                className="cursor-pointer p-3 py-4 justify-between items-start flex-row border-b-[1px] border-gray-700 rounded-none"
              >
                <div className="flex ">
                <img
                  className="w-[20px] h-[20px] mr-3"
                  alt="Edit Profile"
                  src={editprofileIcon}
                />
                  <div><span dangerouslySetInnerHTML={{ __html: t("Header.viewAsOwner") }} /></div>
                </div>
                <img
                  className="w-[16px] h-[16px]"
                  alt="No Image"
                  src={ChevronRight}
                />
              </DropdownMenuItem>
            )}
            <DropdownMenuItem
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
                navigate(`/edit-profile`,{state:{
                  from:window.location.pathname
                }});
              }}
              className="cursor-pointer p-3 py-4 justify-between items-start flex-row border-b-[1px] border-gray-700 rounded-none"
            >
              <div className="flex ">
                <img
                  className="w-[20px] h-[20px] mr-3"
                  alt="Edit Profile"
                  src={editprofileIcon}
                />
                <div><span dangerouslySetInnerHTML={{ __html: t("Common.editProfile") }} /></div>
              </div>
              <img
                className="w-[16px] h-[16px]"
                alt="No Image"
                src={ChevronRight}
              />
            </DropdownMenuItem>

            <DropdownMenuItem
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
                navigate("/user-settings");
              }}
              className="cursor-pointer p-3 py-4 justify-between items-start flex-row border-b-[1px] border-gray-700 rounded-none"
            >
              <div className="flex ">
                <img
                  className="w-[20px] h-[20px] mr-3"
                  alt="Setting"
                  src={Setting}
                />
                <div><span dangerouslySetInnerHTML={{ __html: t("Header.settings") }} /></div>
              </div>
              <img
                className="w-[16px] h-[16px]"
                alt="No Image"
                src={ChevronRight}
              />
            </DropdownMenuItem>
            

            {socialLogin && (
              <DropdownMenuItem
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  navigate(`/update-password`,{state:{
                    from:window.location.pathname
                  }});
                }}
                className="cursor-pointer p-3 py-4 justify-between items-start flex-row border-b-[1px] border-gray-700 rounded-none"
              >
                <div className="flex ">
                  <img
                    className="w-[20px] h-[20px] mr-3"
                    alt="No Image"
                    src={ChangePassword}
                  />
                  <div><span dangerouslySetInnerHTML={{ __html: t("Header.changePassword") }} /></div>
                </div>
                <img
                  className="w-[16px] h-[16px]"
                  alt="No Image"
                  src={ChevronRight}
                />
              </DropdownMenuItem>
            )}

<DropdownMenuItem
              onClick={() => navigate("/video-tutorials")}
              className="cursor-pointer p-3 py-4 justify-between items-start flex-row border-b-[1px] border-gray-700 rounded-none"
            >
              <div className="flex ">
                <img
                  className="w-[20px] h-[20px] mr-3"
                  alt="Tutorial Video"
                  src={InfoCircle}
                />
                <div><span dangerouslySetInnerHTML={{ __html: t("Header.tutorialVideo") }} /></div>
              </div>
              <img
                className="w-[16px] h-[16px]"
                alt="No Image"
                src={ChevronRight}
              />
            </DropdownMenuItem>
          </ScrollArea>

          <DropdownMenuItem className="cursor-pointer p-3 justify-center text-center hidden">
            <div className="flex items-center">
              <button
                onClick={() => {
                  const redirectPaths = getRedirectPaths(location, 'terms-of-services');
                  localStorage.setItem('redirectPaths', JSON.stringify(redirectPaths));
                  navigate('/terms-of-services');
                }}
                className="hover:underline mr-3 font-medium text-sm"
              >
                <span dangerouslySetInnerHTML={{ __html: t("LogIn.termConditions") }} />
              </button>
              <DropdownMenuShortcut className="mr-3">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="ml-auto h-4 w-4"
                >
                  <path
                    d="M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </DropdownMenuShortcut>
              <button
                onClick={() => {
                  const redirectPaths = getRedirectPaths(location, 'privacy-policy');
                  localStorage.setItem('redirectPaths', JSON.stringify(redirectPaths));
                  navigate('/privacy-policy');
                }}
                className="hover:underline font-medium text-sm"
              >
                {" "}
                <span dangerouslySetInnerHTML={{ __html: t("LogIn.privacyPolicy") }} />
              </button>
            </div>
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => onHandleLogout()}
            className="cursor-pointer p-3 justify-center text-center font-opensansSemiBold text-sm pt-4"
          >
            <span dangerouslySetInnerHTML={{ __html: t("Header.logOut") }} />
            <img
              className="w-[20px] h-[20px]"
              alt="No Image"
              src={ChevronRight}
            />
          </DropdownMenuItem>
        </DropdownMenuContent>
      </div>
    </DropdownMenu>
  );
};
